import { render, staticRenderFns } from "./Joinus.vue?vue&type=template&id=27bd4ed6&"
import script from "./Joinus.vue?vue&type=script&lang=js&"
export * from "./Joinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports